import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";

const STATUS_COLOR = { VERIFIED: "text-emerald-400 border-emerald-400/30", QUALIFIED: "text-cyan-400 border-cyan-400/30", PLANNED: "text-amber-400 border-amber-400/30", PROHIBITED: "text-red-400 border-red-400/30", EXPIRED: "text-paper/40 border-white/20" };

export default function Registry() {
  const [tab, setTab] = useState("claims");
  const [claims, setClaims] = useState([]);
  const [questions, setQuestions] = useState([]);
  useEffect(() => {
    api.get("/admin/claims").then((r) => setClaims(r.data));
    api.get("/admin/questions").then((r) => setQuestions(r.data));
  }, []);
  return (
    <AdminLayout>
      <div className="p-8 md:p-10">
        <div className="eyebrow text-heraldic mb-1">Compliance</div>
        <h1 className="font-serif text-4xl text-paper">Registry</h1>
        <div className="mt-6 flex gap-2">
          {[["claims", `Claims (${claims.length})`], ["questions", `Question bank (${questions.length})`]].map(([v, l]) => (
            <button key={v} data-testid={`registry-tab-${v}`} onClick={() => setTab(v)} className={`px-4 py-1.5 text-sm rounded-sm border transition-colors ${tab === v ? "bg-heraldic text-white border-heraldic" : "border-white/15 text-paper/60"}`}>{l}</button>
          ))}
        </div>

        {tab === "claims" && (
          <div className="mt-6 border border-white/10 rounded-sm overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-paper/50"><tr><th className="text-left p-3 font-medium">Claim</th><th className="text-left p-3 font-medium">Category</th><th className="text-left p-3 font-medium">Status</th><th className="text-left p-3 font-medium">Public</th></tr></thead>
              <tbody>
                {claims.map((c, i) => (
                  <tr key={i} className="border-t border-white/10">
                    <td className="p-3 text-paper/80 max-w-md">{c.wording_en}{c.qualification && <div className="text-xs text-paper/40 mt-0.5">{c.qualification}</div>}</td>
                    <td className="p-3 text-paper/50">{c.category}</td>
                    <td className="p-3"><span className={`text-xs border px-2 py-0.5 rounded-sm ${STATUS_COLOR[c.status] || ""}`}>{c.status}</span></td>
                    <td className="p-3">{c.public ? <span className="text-emerald-400">Yes</span> : <span className="text-paper/40">No</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {tab === "questions" && (
          <div className="mt-6 border border-white/10 rounded-sm overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-paper/50"><tr><th className="text-left p-3 font-medium">ID</th><th className="text-left p-3 font-medium">Title</th><th className="text-left p-3 font-medium">Stage</th><th className="text-left p-3 font-medium">Domain</th><th className="text-left p-3 font-medium">Diff</th><th className="text-left p-3 font-medium">Status</th></tr></thead>
              <tbody>
                {questions.map((q) => (
                  <tr key={q.qid} className="border-t border-white/10">
                    <td className="p-3 font-mono text-xs text-heraldic">{q.qid}</td>
                    <td className="p-3 text-paper/80">{q.title}</td>
                    <td className="p-3 text-paper/50">{q.stage}</td>
                    <td className="p-3 text-paper/50">{q.domain}</td>
                    <td className="p-3 font-mono text-paper/60">{q.difficulty}</td>
                    <td className="p-3"><span className="text-xs text-emerald-400 border border-emerald-400/30 px-2 py-0.5 rounded-sm">{q.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
